import { Button, Form, Radio, RadioChangeEvent } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Transfer, { TransferDirection } from 'antd/es/transfer';
import GeneralHeader from 'components/common/GeneralHeader';
import { CustomInput } from 'components/custom';
import { useFormik } from 'formik';
import useMember from 'hooks/useMember';
import useNotice from 'hooks/useNotice';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const AddModel = () => {
  const { createModal, getTaskOption } = useMember();
  const location = useLocation();
  const navigate = useNavigate();
  const { errorNotification, error } = useNotice();

  const [targetKeys, setTargetKeys] = useState(
    location?.state?.data
      ? location.state.data.tasks.map((item) => {
          return item.id;
        })
      : [],
  );

  const [selectedKeys, setSelectedKeys] = useState([]);
  const [listTasksData, setListTasksData] = useState([]);

  const formik = useFormik({
    initialValues: {
      model_type: location?.state?.data
        ? location.state.data.model_type
        : 'on_boarding',
      title: '',
      description: location?.state?.data ? location.state.data.description : '',
      task_ids: location?.state?.data
        ? location.state.data.tasks.map((item) => {
            return item.id;
          })
        : [],
    },
    onSubmit: (data) => {
      createModal(data)
        .then((res) => {
          if (res.status === 201) {
            navigate('/boarding_management/add_a_model_succeed', {
              state: { title: data.title },
            });
          }
        })
        .catch((e) => {
          errorNotification('This model has been existed!');
        });
    },
  });

  useEffect(() => {
    getTaskOption().then((response) => {
      setListTasksData(
        response?.data?.map((item) => {
          return {
            key: item.id,
            title: item.title,
            model_type: item.model_type,
          };
        }),
      );
    });
  }, []);

  const onChange = (
    nextTargetKeys: string[],
    direction: TransferDirection,
    moveKeys: string[],
  ) => {
    setTargetKeys(nextTargetKeys);
    formik.setFieldValue('task_ids', nextTargetKeys);
  };

  const onSelectChange = (
    sourceSelectedKeys: string[],
    targetSelectedKeys: string[],
  ) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };
  // const success = () => {
  //   Modal.success({
  //     content: 'Task created successfuly ',
  //     onOk: () => navigate('/checklist_template'),
  //   });
  // };

  return (
    <div>
      <GeneralHeader
        // showBreadcrumb={false}
        child={
          <Form onFinish={formik.handleSubmit}>
            <div
              style={{
                fontWeight: '700',
                marginTop: '40px',
                fontSize: '24px',
                color: '#000',
              }}
            >
              {location?.state?.data ? 'Copy a model' : 'Add a model'}
            </div>
            <div style={{ marginTop: 65 }}>
              <span style={{ color: '#000' }}>Model Type </span>
              <span style={{ color: '#E02C2C' }}>* </span>
            </div>
            <Radio.Group
              onChange={(e: RadioChangeEvent) =>
                formik.setFieldValue('model_type', e.target.value)
              }
              style={{ marginTop: '30px', fontSize: '16px' }}
              defaultValue={
                location?.state?.data
                  ? location.state.data.model_type
                  : 'on_boarding'
              }
            >
              <Radio
                className="add_user_first_step_text"
                value="on_boarding"
                style={{ color: '#000' }}
              >
                Onboarding
              </Radio>
              <Radio
                className="add_user_first_step_text"
                value="off_boarding"
                style={{ marginLeft: '40px', color: '#000' }}
              >
                Offboarding
              </Radio>
            </Radio.Group>
            <div style={{ marginTop: '50px' }} className={'leave_request_form'}>
              <CustomInput
                onChange={(s) => formik.setFieldValue('title', s.target.value)}
                background="white"
                width="100%"
                title="Title of model"
                required
                fontSize={12}
                maxLength={100}
                // defaultValue={location?.state?.data?.title}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                }}
              />
              <div
                style={{ marginTop: '32px' }}
                className="on_boarding_creation_task_text_area"
              >
                <div className="checklist_des_text">Description</div>
                <TextArea
                  defaultValue={location?.state?.data?.description}
                  onChange={(e: any) =>
                    formik.setFieldValue('description', e.target.value)
                  }
                  style={{
                    fontWeight: 400,
                    fontSize: 12,
                    fontFamily: 'IBM Plex Serif',
                    paddingLeft: 16,
                  }}
                  bordered={false}
                  rows={6}
                  autoSize={{ minRows: 7 }}
                  maxLength={200}
                />
              </div>
            </div>
            <div
              style={{ marginTop: '50px', marginBottom: '50px ' }}
              className={'leave_request_form'}
            >
              <Transfer
                dataSource={listTasksData.filter(
                  (item) => item.model_type === formik.values.model_type,
                )}
                titles={['All tasks', 'Selected tasks']}
                showSearch
                showSelectAll={false}
                targetKeys={targetKeys}
                selectedKeys={selectedKeys}
                onChange={onChange}
                onSelectChange={onSelectChange}
                listStyle={{
                  width: '50%',
                  height: 400,
                  background: 'white',
                  fontSize: 12,
                  color: '#000000',
                  border: '0.5px solid #407FDD',
                }}
                onSearch={() => {}}
                render={(item) => item.title}
              />
            </div>
            <div
              style={{
                display: 'flex',
                float: 'right',
                gap: 16,
                marginTop: 20,
                marginBottom: 40,
              }}
            >
              <Button
                onClick={() => navigate(-1)}
                className="checklist_add_button"
                style={{
                  background: '#fff',
                  color: '#407FDD',
                  fontSize: '16px',
                  fontWeight: 700,
                }}
              >
                CANCEL
              </Button>
              <Button
                htmlType="submit"
                type={'primary'}
                className="checklist_add_button"
                style={{
                  fontSize: '16px',
                  fontWeight: 700,
                }}
              >
                ADD
              </Button>
            </div>
          </Form>
        }
      />
    </div>
  );
};

export default AddModel;
